import React from 'react';
import axios from 'axios';

const ExportCSV = ({ token }) => {
  const exportData = async (endpoint, fallbackName, errorMessage) => {
    try {
      const response = await axios.get(`https://genz-staging.feeltiptop.com${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      const disposition = response.headers['content-disposition'];
      const filename =
        disposition && disposition.includes('filename=')
          ? disposition.split('filename=')[1].replace(/"/g, '')
          : `${fallbackName}-${new Date().toISOString().split('T')[0]}.csv`;

      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export failed:', err);
      alert(errorMessage);
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 justify-center items-center mt-8">
      <button
        onClick={() =>
          exportData(
            '/api/social_glass/export-ambassador-profiles',
            'ambassador-profiles',
            'Failed to export ambassador profiles.'
          )
        }
        className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg shadow"
      >
        Download Ambassador Profiles CSV
      </button>

      <button
        onClick={() =>
          exportData(
            '/api/social_glass/data-dump',
            'data-dump',
            'Failed to export post metadata.'
          )
        }
        className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg shadow"
      >
        Download Post Metadata CSV
      </button>
    </div>
  );
};

export default ExportCSV;
